'use client';

import React, { JSX } from 'react';

import {
    Button,
    Dialog,
    DialogContent,
    DialogHeader,
    DialogFooter,
    DialogDescription,
    DialogClose,
    DialogTitle,
} from '@videoblocks/design-system';

export type ModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    confirmDisabled?: boolean;
    title: string;
    primaryActionText: React.ReactNode;
    body: React.ReactNode;
};

const Modal = ({
    isOpen,
    onClose,
    onConfirm,
    confirmDisabled,
    title,
    primaryActionText,
    body,
}: ModalProps): JSX.Element => (
    <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="min-w-[40rem] top-[35%]">
            <DialogHeader>
                <DialogTitle>{title}</DialogTitle>
            </DialogHeader>
            <DialogDescription className="sr-only">{title}</DialogDescription>
            {body}
            <DialogFooter>
                <DialogClose asChild>
                    <Button variant="outlined-dark">Cancel</Button>
                </DialogClose>
                <Button disabled={confirmDisabled} onClick={onConfirm}>
                    {primaryActionText}
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
);

export default Modal;
